<template>
    <div class="page-main" :class="[$store.state.folding ? 'folded':'']" v-loading.fullscreen.lock="$store.state.loading">
        <template v-if="template === 'default'">
            <main-header></main-header>
            <div class="page-main-content">
                <div class="slide-menu-wrap">
                    <main-menu></main-menu>
                </div>
                <div class="page-right-content">
                    <div class="main-view">
                        <router-view :class="['main-container',classScoped]"></router-view>
                    </div>
                    <main-footer class="hide"></main-footer>
                </div>
            </div>
        </template>
        <template v-else-if="template === 'full'">
            <router-view :class="[classScoped]"></router-view>
        </template>
    </div>
</template>

<script type="text/javascript">
    import Header from 'views/common/header'
    import Footer from 'views/common/footer'
    import Menu from 'views/common/menu'

    export default {
        data () {
            return {}
        },
        props: ['template'],
        components: {
            mainHeader: Header,
            mainFooter: Footer,
            mainMenu: Menu
        },
        computed: {
            classScoped () {
                let path = (this.$route.path || '').replace(/^\//, '')
                return `scoped-${path.split('/').join('-')}`
            }
        }
    }
</script>
<style type="text/scss">
    @import "~style/app/index";
</style>


// WEBPACK FOOTER //
// app.vue?98df935c